/* global AV, soundManager */
import { AudioPlayer } from './AudioPlayer'

/**
 *
 * Gestionnaire de lecture audio sans aucune logique autre que la lecture audio de navigateur web, et de callbacks
 *
 */
export default class WebAudioPlayer extends AudioPlayer {
	audio = null
	preloading = false

	preload() {
		if (!this.audio) {
			this.audio = new Audio('/public/resources/music/blank.mp3')
			this.preloading = true
		}
	}

	load(trackData, fileUrlData, autoPlay = true, initialSeek = 0, volume = 100) {
		super.load(trackData, fileUrlData, autoPlay, initialSeek, volume)
		this.onProgressChanged(0)
		this.onBufferChanged([{
			start: 0,
			end: 0
		}])
		const self = this

		this.onLoadedTrack()

		if (this.audio) {
			this.audio.currentTime = 0
			this.audio.src = fileUrlData.url
		} else {
			this.audio = new Audio(fileUrlData.url)
		}
		this.audio.play()
		this.audio.addEventListener('waiting', () => {
			self.onBuffering()
		})
		this.audio.addEventListener('play', () => {
			this.onPlayedTrack()
		})
		this.audio.addEventListener('pause', () => {
		})
		this.audio.addEventListener('playing', () => {
			if (!this.preloading) {
				self.onBufferingEnded()
			} else {
				this.preloading = false
			}
		})
		this.audio.addEventListener('timeupdate', () => {
			const timestamp = this.audio.currentTime
			if (!this.preloading) {
				self.onProgressChanged(timestamp)
			}
		})
		this.audio.addEventListener('ended', () => {
			this.onTrackEnded()
		})
	}

	closeMusic() {
		if (this.audio) {
			this.audio.pause()
		}
	}

	play(dontPlay) {
		if (this.audio) {
			this.audio.play()
			this.onPlayedTrack()
		}
	}

	stop() {
		if (this.audio) {
			this.audio.play()
			this.onProgressChanged(0)
			this.onBufferChanged([{
				start: 0,
				end: 0
			}])
			this.onPausedTrack()
		}
	}

	pause() {
		if (this.audio) {
			this.audio.pause()
			this.onPausedTrack()
		}
	}

	seek(position) {
		if (this.audio) {
			this.audio.currentTime = position
			return true
		}
		return false
	}

	setVolume(volume) {
		if (this.audio) {
			this.audio.media = volume / 100
		}
	}

	prepareNextTrack(trackData, fileUrlData) {
		super.prepareNextTrack(trackData, fileUrlData)
		this.onPreparedNextTrack()
	}

	switchNextTrack() {
		let response = null
		if (this.nextTrackData) {
			response = {
				trackData: this.nextTrackData,
				fileUrl: this.nextFileUrlData
			}
			this.load(this.nextTrackData, this.nextFileUrlData, true, 0, 100)
		}
		this.onSwitchedNextTrack(response)

		return response
	}
}



// WEBPACK FOOTER //
// ./src/components/miniPlayer/AudioPlayer/WebAudioPlayer.js